import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Button,
    Table,
    message,
    Input,
    Select,
    Tooltip,
    Tag,
    Row,
    Modal,
    Form,
    Switch,
    Radio,
    InputNumber,
    Badge,
    Pagination,
    Statistic,
    Dropdown,
    Menu,
    Icon,
} from "antd";

// 表单数据
const formData = {
    rate_id: undefined,
    avail_fee_rate: undefined,
    avail_ins_rate: undefined,
    avail_cowboy_rate: undefined,
    ins_mod: undefined,
    cowboy_mod: undefined,
};

export default class ClubList extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        showApplicationRecord: false, // 是否显示申请记录弹窗
        loading: false, // 是否加载中
        applicationLoading: false, // 是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            search_type: undefined,
            search_value: undefined,
        },
        applicationQueryParams: {
            // 查询参数
            status: -1,
            page: 1,
            limit: 20,
            total: 0,
        },
        formData: { ...formData }, // 表单数据,
        data: [], // 表格数据
        accountInfo: {}, // 账号信息
        applicationRecordData: [], // 申请数据
        dataInfo: {}, // 数据信息
        applicationRecordDataInfo: {}, // 申请数据信息
        localCurrencyRatioList: [], // 俱乐部积分比例列表
        typeList: [
            // 类型列表
            { value: "club_id", label: this.props.language["clubId"] },
            { value: "club_name", label: this.props.language["clubName"] },
            { value: "user_id", label: this.props.language["clubOwnerId"] },
            { value: "user_name", label: this.props.language["clubOwnerName"] },
        ],
        statusList: [
            // 状态列表
            { value: 0, label: this.props.language["pending"] },
            { value: 1, label: this.props.language["rejected"] },
            { value: 2, label: this.props.language["agreed"] },
        ],
        selectedData: {}, // 选中的表格数据
    };

    componentDidMount () {
        this.fetchData();
        this.fetchAccountInfo();
        this.fetchLocalCurrencyRatioList();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/union_select_club_pkc", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                    dataInfo: res || {},
                });
            });
    };

    /**
     * 获取账号信息
     */
    fetchAccountInfo = async () => {
        axios.get(`/v1/api/union_detail`).then((res) => {
            this.setState({
                accountInfo: res.data || {},
            });
        });
    };

    /**
     * 获取本地币比例列表
     */
    fetchLocalCurrencyRatioList = async () => {
        axios.get(`/v1/api/local_coin/union_rate_conf_list`).then((res) => {
            let rate = {
                id: 0,
                rate: 1
            }
            this.setState({
                localCurrencyRatioList: res.data ? [rate, ...res.data] : [rate],
            });
        });
    };

    /**
     * 获取申请记录数据
     */
    fetchApplicationRecordData = () => {
        this.setState({ applicationLoading: true });
        axios
            .get(
                Cookie.get("isDirect") === "false"
                    ? "/v1/api/union_club_join_list"
                    : "/v1/api/direct_union/vendor_apply_list",
                {
                    params: {
                        ...this.state.applicationQueryParams,
                        total: undefined,
                    },
                }
            )
            .then((res) => {
                this.setState({
                    applicationLoading: false,
                    applicationQueryParams: {
                        ...this.state.applicationQueryParams,
                        total: res.count || 0,
                    },
                    applicationRecordData: res.data || [],
                    applicationRecordDataInfo: res || {},
                });
            });
    };

    /**
     * 设置是否能创建牌局
     */
    handleSetAllowCreate = (club_id, value) => {
        axios
            .patch("v1/api/union_club_allow_create", {
                id: club_id,
                allow: value,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["setSuccessMessage"]);
                    this.fetchData();
                }
            });
    };

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.type === "editProportion") {
                    // 编辑分成
                    axios
                        .patch(
                            `/v1/api/union_modify_proportion/${this.state.formData.club_id}`,
                            {
                                rate_id: values.rate_id,
                                avail_fee_rate: Number(values.avail_fee_rate),
                                avail_ins_rate: Number(values.avail_ins_rate),
                                avail_cowboy_rate: Number(values.avail_cowboy_rate),
                                ins_mod: Number(values.ins_mod),
                                cowboy_mod: Number(values.cowboy_mod),
                            }
                        )
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (
                    this.state.type === "sendIntegral" ||
                    this.state.type === "recycleIntegral"
                ) {
                    // 发放、回收积分
                    axios
                        .patch("/v1/api/trans_point", {
                            amount:
                                this.state.type === "sendIntegral"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.selectedData.club_id),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (
                    this.state.type === "sendDiamond" ||
                    this.state.type === "recycleDiamond"
                ) {
                    // 发放、回收钻石
                    axios
                        .patch("/v1/api/diamond/union/club", {
                            amount:
                                this.state.type === "sendDiamond"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            id: Number(this.state.selectedData.club_id),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (this.state.type === "contribution") {
                    // 更新服务费贡献比例设置
                    axios
                        .patch("/v1/api/union_modify_club_rebate", {
                            win: Number(values.win),
                            lose: Number(values.lose),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (this.state.type === "agreeApplication") {
                    // 同意俱乐部申请
                    this.handleOperationApplication("pass", {
                        ...this.state.formData,
                        rate_id: values.rate_id,
                        avail_fee_rate: Number(values.avail_fee_rate),
                        avail_ins_rate: Number(values.avail_ins_rate),
                        avail_cowboy_rate: Number(values.avail_cowboy_rate),
                        ins_mod: Number(values.ins_mod),
                        cowboy_mod: Number(values.cowboy_mod),
                    });
                }
            }
        });
    };

    /**
     * 同意、拒绝俱乐部申请
     */
    handleOperationApplication = (type, item) => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: `${type === "pass"
                ? this.props.language["agreenConfirm"]
                : this.props.language["refuseConfirm"]
                }`,
            onOk: () => {
                axios
                    .patch(
                        Cookie.get("isDirect") === "false"
                            ? `v1/api/union_club_join_union/${item.club_id}`
                            : `/v1/api/direct_union/audit_vendor_apply`,
                        Cookie.get("isDirect") === "false"
                            ? {
                                option: type,
                                rate_id: item.rate_id,
                                avail_fee_rate: item.avail_fee_rate,
                                avail_ins_rate: item.avail_ins_rate,
                                avail_cowboy_rate: item.avail_cowboy_rate,
                                ins_mod: item.ins_mod,
                                cowboy_mod: item.cowboy_mod,
                            }
                            : {
                                email: item.email,
                                status: type === "pass" ? 2 : 1,
                            }
                    )
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(
                                type === "pass"
                                    ? this.props.language["agreeApplicationMessage"]
                                    : this.props.language["refuseApplicationMessage"]
                            );
                            this.fetchData();
                            this.fetchApplicationRecordData();
                            this.setState({ show: false });
                        }
                    });
            },
        });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        let title;
        switch (type) {
            case "sendIntegral":
                title = this.props.language["sendIntegral"];
                break;
            case "recycleIntegral":
                title = this.props.language["recycleIntegral"];
                break;
            case "sendDiamond":
                title = this.props.language["sendDiamond"];
                break;
            case "recycleDiamond":
                title = this.props.language["recycleDiamond"];
                break;
            case "editProportion":
                title = this.props.language["editProportion"];
                break;
            case "contribution":
                title = this.props.language["unionServiceContributionProportion"];
                break;
            case "agreeApplication":
                title = `${this.props.language["agreeApplication"]}（${this.props.language["editProportion"]}）`;
                break;
        }
        let newFormData = {};
        if (type === "contribution") {
            newFormData = {
                win: this.state.dataInfo.positive_profit_prop,
                lose: this.state.dataInfo.negative_profit_prop,
            };
        } else if (type === "agreeApplication") {
            newFormData = {
                club_id: item.club_id,
                rate_id: item.union_rate_id === -1 ? undefined : item.union_rate_id,
                avail_fee_rate: this.state.applicationRecordDataInfo.avail_fee_rate,
                avail_ins_rate: this.state.applicationRecordDataInfo.avail_ins_rate,
                avail_cowboy_rate: this.state.applicationRecordDataInfo.avail_cowboy_rate,
                ins_mod: 1,
                cowboy_mod: 1,
            };
        } else if (type === "editProportion") {
            newFormData = {
                club_id: item.club_id,
                rate_id: item.union_rate_id === -1 ? undefined : item.union_rate_id,
                avail_fee_rate: item.club_avail_fee_rate,
                avail_ins_rate: item.club_avail_ins_rate,
                avail_cowboy_rate: item.club_avail_cowboy_rate,
                ins_mod: item.club_ins_mod || undefined,
                cowboy_mod: item.club_cowboy_mod || undefined,
            };
        } else {
            this.state.selectedData = { ...item };
        }
        this.setState({
            show: true,
            type,
            title,
            formData: newFormData,
        });
    };

    /**
     * 显示申请记录弹窗
     */
    handleshowApplicationRecord = () => {
        this.setState({
            showApplicationRecord: true,
        });
        this.fetchApplicationRecordData();
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false, formData: { ...formData } });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    search_type: undefined,
                    search_value: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["searchTypePlaceholder"]}
                        value={this.state.queryParams.search_type}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("search_type", value)
                        }
                    >
                        {this.state.typeList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Input
                        maxLength={60}
                        allowClear
                        placeholder={this.props.language["searchContentPlaceholder"]}
                        value={this.state.queryParams.search_value}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("search_value", e.target.value)
                        }
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button type="link" onClick={this.handleshowApplicationRecord}>
                        {Cookie.get("isDirect") === "false"
                            ? this.props.language["clubApplicationRecord"]
                            : this.props.language["proxyApplicationRecord"]}
                        <Badge
                            style={{ margin: "-16px 0 0 0px" }}
                            count={this.state.dataInfo.numbers_of_join_apply}
                        />
                    </Button>
                    {Cookie.get("isDirect") === "true" && (
                        <Button
                            type="link"
                            onClick={() =>
                                window.open(
                                    `${process.env.REACT_APP_RECRUITING_AGENTS_ADDRESS}?ref=${this.state.accountInfo.union_id}`
                                )
                            }
                        >
                            <span>{this.props.language["recruitmentAgentLink"]}</span>
                            <span>
                                {" "}
                                （
                                {`${process.env.REACT_APP_RECRUITING_AGENTS_ADDRESS}?ref=${this.state.accountInfo.union_id}`}
                                ）
                            </span>
                        </Button>
                    )}
                </div>

                {/* 概况 */}
                <Row type="flex" className="m10 mb0">
                    {Cookie.get("isDirect") === "false" && (
                        <>
                            {/* 柜台积分 */}
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic value={Number(this.state.dataInfo.point || 0)} />
                                        <p lassName="label">
                                            {this.props.language["counterPoint"]}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 柜台钻石 */}
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(this.state.dataInfo.diamond || 0)}
                                        />
                                        <p lassName="label">
                                            {this.props.language["counterDiamond"]}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {/* 可用占比 */}
                    <div className="number-box-list">
                        <p>{this.props.language["availableProportion"]}</p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.avail_fee_rate || 0)}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["serviceFee"]}</p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.avail_ins_rate || 0)}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["insurance"]}</p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(this.state.dataInfo.avail_cowboy_rate || 0)}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["cowboy"]}</p>
                            </div>
                        </div>
                    </div>

                    {/* 上级超盟服务费贡献比例 */}
                    <div className="number-box-list">
                        <p>
                            {this.props.language["superUnionServiceContributionProportion"]}
                        </p>
                        <div className="value-list">
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.super_positive_profit_prop || 0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["winner"]}</p>
                            </div>
                            <div className="value-item">
                                <Statistic
                                    value={Number(
                                        this.state.dataInfo.super_negative_profit_prop || 0
                                    )}
                                    suffix="%"
                                />
                                <p className="label">{this.props.language["underdog"]}</p>
                            </div>
                        </div>
                    </div>
                </Row>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? "small" : "",
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        {Cookie.get("isDirect") === "false" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["clubId"]}
                                dataIndex=""
                                render={(item) => (
                                    <Link to={`/club_detail/${item.club_id}`}>
                                        {item.club_id || ""}
                                    </Link>
                                )}
                            />
                        )}
                        {Cookie.get("isDirect") === "false" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["clubName"]}
                                dataIndex="club_name"
                            />
                        )}
                        <Table.Column
                            align="center"
                            title={
                                Cookie.get("isDirect") === "false"
                                    ? this.props.language["clubOwnerId"]
                                    : this.props.language["proxyId"]
                            }
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/player_detail/${item.user_id}/${item.club_id}`}>
                                    {item.user_id || ""}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={
                                Cookie.get("isDirect") === "false"
                                    ? this.props.language["clubOwnerName"]
                                    : this.props.language["proxyName"]
                            }
                            dataIndex="user_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["joinUnionTime"]}
                            dataIndex="join_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyAmount"]}
                            render={(item) => {
                                return (
                                    item.club_member_cnt && (
                                        <div>
                                            <Tooltip title={this.props.language["superProxy"]}>
                                                <Tag color="purple">
                                                    {item.club_member_cnt.super_agent_cnt}
                                                </Tag>
                                            </Tooltip>
                                            <Tooltip title={this.props.language["oneProxy"]}>
                                                <Tag color="geekblue">
                                                    {item.club_member_cnt.agent_cnt}
                                                </Tag>
                                            </Tooltip>
                                            <Tooltip title={this.props.language["twoProxy"]}>
                                                <Tag color="blue">
                                                    {item.club_member_cnt.agent2_cnt}
                                                </Tag>
                                            </Tooltip>
                                            <Tooltip title={this.props.language["threeProxy"]}>
                                                <Tag color="cyan">
                                                    {item.club_member_cnt.agent3_cnt}
                                                </Tag>
                                            </Tooltip>
                                            <Tooltip title={this.props.language["fourProxy"]}>
                                                <Tag color="green">
                                                    {item.club_member_cnt.agent4_cnt}
                                                </Tag>
                                            </Tooltip>
                                        </div>
                                    )
                                );
                            }}
                        />
                        {Cookie.get("isDirect") === "false" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["palyerNumber"]}
                                dataIndex="club_member_cnt.user_cnt"
                            />
                        )}
                        {Cookie.get("isDirect") === "false" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["counterPoint"]}
                                dataIndex="point"
                            />
                        )}
                        {Cookie.get("isDirect") === "false" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["counterDiamond"]}
                                dataIndex="diamond"
                            />
                        )}
                        {Cookie.get("isDirect") === "false" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["clubPointsRatio"]}
                                dataIndex=""
                                render={(item) => {
                                    let rate = this.state.localCurrencyRatioList.find(
                                        (item2) => item2.id === item.union_rate_id
                                    )
                                    if (rate) {
                                        return rate.id === 0 ? `1:${rate.rate}` : `${rate.currency_name}（1:${rate.rate}）`
                                    }
                                }}
                            />
                        )}
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceProportion"]}
                            dataIndex=""
                            render={(item) => `${item.club_avail_fee_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceProportion"]}
                            dataIndex=""
                            render={(item) => `${item.club_avail_ins_rate}%`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProportion"]}
                            dataIndex=""
                            render={(item) => `${item.club_avail_cowboy_rate}%`}
                        />
                        {Cookie.get("isDirect") === "false" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["insuranceDivide"]}
                                dataIndex=""
                                render={(item) =>
                                    `${item.club_ins_mod === 1 ? this.props.language["traditionMode"] : this.props.language["evMode"]}`
                                }
                            />
                        )}
                        {Cookie.get("isDirect") === "false" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["cowboyDivide"]}
                                dataIndex=""
                                render={(item) =>
                                    `${item.club_cowboy_mod === 1
                                        ? this.props.language["traditionMode"]
                                        : this.props.language["evMode"]
                                    }`
                                }
                            />
                        )}
                        {Cookie.get("isDirect") === "false" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["allowCreateTable"]}
                                dataIndex=""
                                fixed={isMobileDevice() ? false : "right"}
                                width={120}
                                render={(item) => {
                                    return (
                                        <Switch
                                            checked={item.allow_create === 1}
                                            onChange={(value) =>
                                                this.handleSetAllowCreate(item.club_id, value)
                                            }
                                        />
                                    );
                                }}
                            />
                        )}
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={120}
                            render={(item) => (
                                <>
                                    {Cookie.get("isDirect") === "false" ? (
                                        <Dropdown
                                            trigger={["click"]}
                                            overlay={
                                                <Menu onClick={({ key }) => this.handleShow(key, item)}>
                                                    <Menu.Item key="sendIntegral">
                                                        {this.props.language["sendIntegral"]}
                                                    </Menu.Item>
                                                    <Menu.Item key="recycleIntegral">
                                                        {this.props.language["recycleIntegral"]}
                                                    </Menu.Item>
                                                    <Menu.Item key="sendDiamond">
                                                        {this.props.language["sendDiamond"]}
                                                    </Menu.Item>
                                                    <Menu.Item key="recycleDiamond">
                                                        {this.props.language["recycleDiamond"]}
                                                    </Menu.Item>
                                                    <Menu.Item key="editProportion">
                                                        {this.props.language["editProportion"]}
                                                    </Menu.Item>
                                                </Menu>
                                            }
                                        >
                                            <Button type="primary" ghost>
                                                {this.props.language["operation"]}
                                                <Icon type="down" />
                                            </Button>
                                        </Dropdown>
                                    ) : (
                                        <Dropdown
                                            trigger={["click"]}
                                            overlay={
                                                <Menu onClick={({ key }) => this.handleShow(key, item)}>
                                                    <Menu.Item key="editProportion">
                                                        {this.props.language["editProportion"]}
                                                    </Menu.Item>
                                                </Menu>
                                            }
                                        >
                                            <Button type="primary" ghost>
                                                {this.props.language["operation"]}
                                                <Icon type="down" />
                                            </Button>
                                        </Dropdown>
                                    )}
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    localCurrencyRatioList={this.state.localCurrencyRatioList}
                    onOk={this.handleSubmit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />

                {/* 记录弹窗 */}
                <RecordModal
                    {...this.props}
                    visible={this.state.showApplicationRecord}
                    title={
                        Cookie.get("isDirect") === "false"
                            ? this.props.language["clubApplicationRecord"]
                            : this.props.language["proxyApplicationRecord"]
                    }
                    loading={this.state.applicationLoading}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        current: this.state.applicationQueryParams.page,
                        pageSize: this.state.applicationQueryParams.limit,
                        total: this.state.applicationQueryParams.total,
                        size: isMobileDevice() ? "small" : "",
                    }}
                    statusList={this.state.statusList}
                    applicationRecordData={this.state.applicationRecordData}
                    handleShow={this.handleShow}
                    handleOperationApplication={this.handleOperationApplication}
                    onCancel={() => this.setState({ showApplicationRecord: false })}
                    onChange={(current, pageSize) =>
                        this.hanldeChangePage({ current, pageSize }, "record")
                    }
                    onShowSizeChange={(current, pageSize) =>
                        this.hanldeChangePage({ current, pageSize }, "record")
                    }
                />
            </div>
        );
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: "70vh",
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            {/* 编辑分成 */}
                            {(this.props.type === "editProportion" ||
                                this.props.type === "agreeApplication") && (
                                    <>
                                        {Cookie.get("canSetLocalCoinRate") === "true" &&
                                            <Form.Item label={this.props.language["clubPointsRatio"]}>
                                                {getFieldDecorator("rate_id", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message:
                                                                this.props.language["clubPointsRatioVerify"],
                                                        },
                                                    ],
                                                    initialValue: this.props.formData.rate_id,
                                                })(
                                                    <Select
                                                        disabled={this.props.formData.rate_id > -1}
                                                        allowClear
                                                        showSearch
                                                        optionFilterProp="children"
                                                        placeholder={this.props.language["clubPointsRatioPlaceholder"]}
                                                    >
                                                        {this.props.localCurrencyRatioList.map((item, index) => (
                                                            <Select.Option value={item.id} key={index}>
                                                                {item.id === 0 ? `1:${item.rate}` : `${item.currency_name}（1:${item.rate}）`}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        }
                                        <Form.Item label={this.props.language["serviceProportion"]}>
                                            {getFieldDecorator("avail_fee_rate", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language["serviceProportionVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.avail_fee_rate,
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    precision={2}
                                                    placeholder={
                                                        this.props.language["serviceProportionPlaceholder"]
                                                    }
                                                    formatter={(value) => `${value}%`}
                                                />
                                            )}
                                        </Form.Item>
                                        <Form.Item label={this.props.language["insuranceProportion"]}>
                                            {getFieldDecorator("avail_ins_rate", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language["insuranceProportionVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.avail_ins_rate,
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    precision={2}
                                                    placeholder={
                                                        this.props.language["insuranceProportionPlaceholder"]
                                                    }
                                                    formatter={(value) => `${value}%`}
                                                />
                                            )}
                                        </Form.Item>
                                        <Form.Item label={this.props.language["cowboyProportion"]}>
                                            {getFieldDecorator("avail_cowboy_rate", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message:
                                                            this.props.language["cowboyProportionVerify"],
                                                    },
                                                ],
                                                initialValue: this.props.formData.avail_cowboy_rate,
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    max={100}
                                                    precision={2}
                                                    placeholder={
                                                        this.props.language["cowboyProportionPlaceholder"]
                                                    }
                                                    formatter={(value) => `${value}%`}
                                                />
                                            )}
                                        </Form.Item>
                                        {Cookie.get("isDirect") === "false" && (
                                            <>
                                                <Form.Item label={this.props.language["insuranceDivide"]}>
                                                    {getFieldDecorator("ins_mod", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    this.props.language["insuranceDivideVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.ins_mod,
                                                    })(
                                                        <Radio.Group>
                                                            <Radio value={1}>
                                                                {this.props.language["traditionMode"]}
                                                            </Radio>
                                                            <Radio value={2}>{this.props.language["evMode"]}</Radio>
                                                        </Radio.Group>
                                                    )}
                                                </Form.Item>
                                                <Form.Item label={this.props.language["cowboyDivide"]}>
                                                    {getFieldDecorator("cowboy_mod", {
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message:
                                                                    this.props.language["cowboyDivideVerify"],
                                                            },
                                                        ],
                                                        initialValue: this.props.formData.cowboy_mod,
                                                    })(
                                                        <Radio.Group>
                                                            <Radio value={1}>
                                                                {this.props.language["traditionMode"]}
                                                            </Radio>
                                                            <Radio value={2}>{this.props.language["evMode"]}</Radio>
                                                        </Radio.Group>
                                                    )}
                                                </Form.Item>
                                            </>
                                        )}
                                    </>
                                )}

                            {/* 发放回收积分/钻石 */}
                            {(this.props.type == "sendIntegral" ||
                                this.props.type == "recycleIntegral" ||
                                this.props.type == "sendDiamond" ||
                                this.props.type == "recycleDiamond") && (
                                    <>
                                        <Form.Item label={this.props.language["amount"]}>
                                            {getFieldDecorator("amount", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["amountVerify"],
                                                    },
                                                ],
                                            })(
                                                <InputNumber
                                                    min={(this.props.type == "sendDiamond" || this.props.type == "recycleDiamond") ? 1 : 0.01}
                                                    max={100000000}
                                                    precision={(this.props.type == "sendDiamond" || this.props.type == "recycleDiamond") ? 0 : 2}
                                                    placeholder={this.props.language["amountPlaceholder"]}
                                                />
                                            )}
                                        </Form.Item>
                                    </>
                                )}

                            {/* 本联盟服务费贡献比例 */}
                            {this.props.type === "contribution" && (
                                <>
                                    <Form.Item label={this.props.language["winner"]}>
                                        {getFieldDecorator("win", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["winnerProportionPlaceholder"],
                                                },
                                            ],
                                            initialValue: this.props.formData.win,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language["winnerProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item label={this.props.language["underdog"]}>
                                        {getFieldDecorator("lose", {
                                            rules: [
                                                {
                                                    required: true,
                                                    message:
                                                        this.props.language["loserProportionPlaceholder"],
                                                },
                                            ],
                                            initialValue: this.props.formData.lose,
                                        })(
                                            <InputNumber
                                                min={0}
                                                max={100}
                                                precision={0}
                                                placeholder={
                                                    this.props.language["loserProportionPlaceholder"]
                                                }
                                                formatter={(value) => `${value}%`}
                                            />
                                        )}
                                    </Form.Item>
                                </>
                            )}
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);

/**
 * 记录弹窗
 */
class RecordModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                }}
                footer={
                    <Pagination
                        {...this.props.pagination}
                        onChange={this.props.onChange}
                        onShowSizeChange={this.props.onShowSizeChange}
                    />
                }
            >
                <div className="container-content">
                    {/* 内容 */}
                    {Cookie.get("isDirect") === "false" ? (
                        <Table
                            dataSource={this.props.applicationRecordData}
                            pagination={false}
                            loading={this.props.loading}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                        >
                            <Table.Column
                                align="center"
                                title={this.props.language["clubId"]}
                                dataIndex=""
                                render={(item) => (
                                    <Link to={`/club_detail/${item.club_id}`}>
                                        {item.club_id || ""}
                                    </Link>
                                )}
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["clubName"]}
                                dataIndex="club_name"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["clubOwnerId"]}
                                dataIndex="club_user_id"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["clubOwnerName"]}
                                dataIndex="club_user_name"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["clubPeopleNumber"]}
                                dataIndex="club_members_numbers"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["applicationTime"]}
                                dataIndex="time"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["messageContent"]}
                                dataIndex="msg_content"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["operation"]}
                                dataIndex=""
                                fixed={isMobileDevice() ? false : "right"}
                                width={220}
                                render={(item) => (
                                    <>
                                        <Button
                                            className="btn-green-ghost"
                                            ghost
                                            onClick={() => this.props.handleShow("agreeApplication", item)}
                                        >
                                            {this.props.language["agree"]}
                                        </Button>
                                        <Button
                                            className="ml10"
                                            ghost
                                            type="danger"
                                            onClick={() =>
                                                this.props.handleOperationApplication("refused", item)
                                            }
                                        >
                                            {this.props.language["refuse"]}
                                        </Button>
                                    </>
                                )}
                            />
                        </Table>
                    ) : (
                        <Table
                            dataSource={this.props.applicationRecordData}
                            pagination={false}
                            loading={this.props.loading}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                        >
                            <Table.Column
                                align="center"
                                title={this.props.language["applicationTime"]}
                                dataIndex="ctime"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["email"]}
                                dataIndex="email"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["username"]}
                                dataIndex="name"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["language"]}
                                dataIndex="lang"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["registerIp"]}
                                dataIndex="register_ip"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["status"]}
                                dataIndex=""
                                render={(item) =>
                                    this.props.statusList.find(
                                        (item2) => item2.value === item.status
                                    )
                                        ? this.props.statusList.find(
                                            (item2) => item2.value === item.status
                                        ).label
                                        : ""
                                }
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["uid"]}
                                dataIndex="uid"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["proxyId"]}
                                dataIndex="club_id"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["operation"]}
                                dataIndex=""
                                fixed={isMobileDevice() ? false : "right"}
                                width={220}
                                render={(item) => (
                                    <>
                                        {item.status !== 2 && (
                                            <Button
                                                className="btn-green-ghost"
                                                ghost
                                                icon="check"
                                                onClick={() =>
                                                    this.props.handleOperationApplication("pass", item)
                                                }
                                            >
                                                {this.props.language["agree"]}
                                            </Button>
                                        )}
                                        {item.status === 0 && (
                                            <Button
                                                className="ml10"
                                                ghost
                                                type="danger"
                                                icon="close"
                                                onClick={() =>
                                                    this.props.handleOperationApplication("refused", item)
                                                }
                                            >
                                                {this.props.language["refuse"]}
                                            </Button>
                                        )}
                                    </>
                                )}
                            />
                        </Table>
                    )}
                </div>
            </Modal>
        );
    }
}
